import React from 'react'
import './style.css'
const FilloutButton = () => {
  return (
    <a className="button" href="https://internal.refcode.org/volunteer">
      Fill out volunteer form
    </a>
  )
}

export default FilloutButton
